import React, { PureComponent } from 'react';
import styles from './Label.module.scss';

interface LabelProps {
  children: React.ReactNode;
}

export class Label extends PureComponent<LabelProps> {
  render() {
    return <label className={styles.container}>{this.props.children}</label>;
  }
}
